import React from "react";
import classNames from "classnames";
import withStyles from "react-jss";

const styles = (theme) => ({
	root: {
		fontSize: 0,
		lineHeight: 0,
	},
	value: {
		display: "inline-block",
		verticalAlign: "top",
		fontFamily: theme.fonts.bold,
		fontSize: "24px",
		lineHeight: 1,
		color: "#000000",
		marginRight: "8px",
	},
	measure: {
		fontFamily: theme.fonts.medium,
		fontSize: "14px",
		lineHeight: 1,
		letterSpacing: "2px",
		color: theme.palette.colors.oneMoreGrey,
		textTransform: "uppercase",
		position: "relative",
		bottom: "-2px",
	},
	isGreen: {
		"& $value": {
			color: "#24ba8e",
		},
		"& $measure": {
			color: "#24ba8e",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			display: "none",
		},
	},
});

const Component = ({ classes, value, measureText, green, text }) => {
	return (
		<div
			className={classNames(classes.root, {
				[classes.isGreen]: green,
			})}
		>
			<span className={classes.value}>{value}</span>
			<span className={classes.measure}>
				{measureText ? measureText : text.SUBSCRIPTION_FEE_TITLE}
			</span>
		</div>
	);
};

Component.defaultProps = {
	green: false,
};

const Price = withStyles(styles)(Component);
Price.displayName = "Price";

export default Price;
